import React,{ useState } from 'react'
import { useNavigate } from 'react-router-dom'
import edge from '../icons/edgeicon.png'
import thispc from '../icons/Computer.png'
import calender from '../icons/calender.png'
import msstore from '../icons/Microsoft_Store_app_icon.png'
import photos from '../icons/photos.svg'
import settings from '../icons/settings.svg'
import office from '../icons/office.svg'
import xbox from '../icons/xbox.png'
import solitaire from '../icons/solitaire.png'
import spotify from '../icons/spotify.png'
import netflix from '../icons/netflix.png'
import todo from '../icons/todo.png'
import news from '../icons/news.png'
import vscode from '../icons/vscode.png'
import twitter from '../icons/twitter.png'
import messenger from '../icons/messenger.png'
import msteam from '../icons/msteam.png'
import Calculator from '../icons/calculator.png'
import nodejs from '../icons/nodejs.png'
import msword from '../icons/msword.png'
import zip from '../icons/7zip.png'
import onedrive from '../icons/onedrive.png'



const Startmenu = () => {

  const [shutdownPanel, setShutdownPanel] = useState(false);

  const navigate = useNavigate();

  const handleLock = () =>{
    navigate('/')
  }

  const handleShutdown = () =>{
    navigate('/onoff')
  }




  return (
    <div className='h-[45rem] w-[38rem] bg-[#ededed] rounded-md p-6 flex flex-col shadow-md shadow-black/40'>

      <div className='header'>
        <input className='w-full outline-none bg-gray-300 rounded-md p-2 text-sm' placeholder='Search app here' type="text" />
        <div className='lowerHeader flex items-center justify-between mt-7 mb-4'>
          <span className='font-bold text-xl'>Pinned</span>
          <select className='bg-gray-200 rounded-md p-1 text-sm'>
            <option value="">All Apps</option>
          </select>
        </div>
      </div>

      <div className='appContainer grid grid-cols-6'>

        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={edge} alt="icon" />
          <span className='text-xs text-center'>Edge</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={thispc} alt="icon" />
          <span className='text-xs text-center'>This PC</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={calender} alt="icon" />
          <span className='text-xs text-center'>Calender</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={msstore} alt="icon" />
          <span className='text-xs text-center'>Microsoft Store</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={photos} alt="icon" />
          <span className='text-xs text-center'>Photos</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={settings} alt="icon" />
          <span className='text-xs text-center'>Setting</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={office} alt="icon" />
          <span className='text-xs text-center'>Office</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={xbox} alt="icon" />
          <span className='text-xs text-center'>Xbox</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={solitaire} alt="icon" />
          <span className='text-xs text-center'>Solitaire</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={spotify} alt="icon" />
          <span className='text-xs text-center'>Spotify</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={netflix} alt="icon" />
          <span className='text-xs text-center'>Netflix</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={todo} alt="icon" />
          <span className='text-xs text-center'>To Do</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={news} alt="icon" />
          <span className='text-xs text-center'>News</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={vscode} alt="icon" />
          <span className='text-xs text-center'>VS Code</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={twitter} alt="icon" />
          <span className='text-xs text-center'>Twitter</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={messenger} alt="icon" />
          <span className='text-xs text-center'>Messenger</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={msteam} alt="icon" />
          <span className='text-xs text-center'>MIcrosoft Teams</span>
        </div>
        <div className='h-24 w-24 flex flex-col justify-center items-center rounded-md hover:bg-gray-300 transition-all ease-in-out delay-75 cursor-default space-y-1'>
          <img className='h-9 w-auto' src={Calculator} alt="icon" />
          <span className='text-xs text-center'>Calculator</span>
        </div>

      </div>

      <h2 className='font-bold text-xl ml-7 py-3'>Recommended</h2>

        <div className='recommended w-full grid grid-cols-2 gap-2 justify-items-center'>

          <div className='item flex items-center space-x-4 w-fit py-3 px-8 rounded-md hover hover:bg-gray-300 cursor-default transition-all ease-in-out delay-75'>
            <img className='h-9 w-auto' src={nodejs} alt="icons" />
            <div className='flex flex-col text-sm'>
              <span>Node.Js</span>
              <span className='text-gray-500'>Recently Added</span>
            </div>
          </div>

          <div className='item flex items-center space-x-4 w-fit py-3 px-8 rounded-md hover hover:bg-gray-300 cursor-default transition-all ease-in-out delay-75'>
            <img className='h-9 w-auto' src={msword} alt="icons" />
            <div className='flex flex-col text-sm'>
              <span>Ms Word</span>
              <span className='text-gray-500'>Recently Added</span>
            </div>
          </div>

          <div className='item flex items-center space-x-4 w-fit py-3 px-8 rounded-md hover hover:bg-gray-300 cursor-default transition-all ease-in-out delay-75'>
            <img className='h-9 w-auto' src={zip} alt="icons" />
            <div className='flex flex-col text-sm'>
              <span>7Zip</span>
              <span className='text-gray-500'>Recently Added</span>
            </div>
          </div>

          <div className='item flex items-center space-x-4 w-fit py-3 px-8 rounded-md hover hover:bg-gray-300 cursor-default transition-all ease-in-out delay-75'>
            <img className='h-9 w-auto' src={onedrive} alt="icons" />
            <div className='flex flex-col text-sm'>
              <span>One Drive</span>
              <span className='text-gray-500'>Recently Added</span>
            </div>
          </div>

        </div>

        <div className='bottomContainer flex items-center justify-between border-t border-gray-300 py-3 px-20 mt-3'>
          <div className='left flex items-center space-x-3 hover:bg-gray-300 cursor-default px-5 py-2 rounded-md'>
            <span className='text-gray-500 text-2xl bg-white rounded-full w-10 h-10 flex justify-center items-center cursor-pointer'><i className="fa-regular fa-user"></i></span>
            <span>Account</span>
          </div>
          <div className='right relative'>
            <span onClick={()=>{shutdownPanel? setShutdownPanel(false): setShutdownPanel(true)}} className='text-black text-xl cursor-pointer hover:bg-gray-300 py-3 px-4 rounded-md'><i className="fa-solid fa-power-off"></i></span>

            <div className= {`${shutdownPanel? 'flex': 'hidden'} absolute left-6 -top-[110px] flex-col bg-white text-sm rounded-md overflow-hidden shadow-md shadow-black/40`}>
              <span onClick={handleLock} className='px-4 py-2 w-full flex items-center hover:bg-gray-100 cursor-default'><i className="mr-1 fa-solid fa-lock"></i> Lock</span>
              <span onClick={handleShutdown} className='px-4 py-2 w-full flex items-center hover:bg-gray-100 cursor-default'><i className="mr-1 fa-solid fa-power-off"></i> Shutdown</span>
              <span className='px-4 py-2 w-full flex items-center hover:bg-gray-100 cursor-default'><i className="mr-1 fa-solid fa-rotate-left"></i> Restart</span>
            </div>

          </div>
        </div>

    </div>
  )
}

export default Startmenu
